module.exports = __webpack_public_path__ + "img/jinbi.25a9b18d.png";